import { useTranslation } from "react-i18next"
import { KpiRow } from "../delivery/atoms"

interface Props {
  active: number
  ready: number
  failed: number
  avgMinutes: number | null
}

/** Хүлээлцэл KPI row (canvas Ord_DeliveryHub, hand tab): neutral white tiles. */
export function HandoverStatsCards({ active, ready, failed, avgMinutes }: Props) {
  const { t } = useTranslation("delivery")
  return (
    <KpiRow
      items={[
        { key: "active", label: t("custody.stats.active"), value: active, meta: t("manage.handover.activeMeta") },
        { key: "ready", label: t("custody.stats.ready"), value: ready, meta: t("manage.handover.readyMeta") },
        { key: "failed", label: t("custody.stats.failed"), value: failed, meta: t("manage.handover.failedMeta") },
        {
          key: "avg",
          label: t("custody.stats.avgTime"),
          value: avgMinutes == null ? "-" : t("custody.stats.minutes", { count: avgMinutes }),
          meta: avgMinutes == null ? t("manage.handover.avgNone") : t("manage.handover.avgMeta"),
        },
      ]}
    />
  )
}
